import {Assessment} from "../models/assessment";
import {QuestionSet} from "../models/question-set";
import {DisplayCondition} from "../models/display-condition";
import { Scale } from "../models/scale";
import { ScaleRange } from "../models/scale-range";

interface CompressedDisplayCondition {
    _answerId:string;
    _questionId:string;
    _questionSetId:string;
    _displayType:"show" | "hide";
}
interface CompressedScale {
    _id: string;
	_name: string;
	_instructions: string;
	_answer_start_value: number;
	_display_order: number;
	_ranges: ScaleRange[];
	_deleted: boolean;
	_multiplier: number;
	_descriptionClient: string;
	_descriptionTherapist: string;
	_negativeToPositiveRanges: boolean;
	_subScaleIds:string[];
}
/**
 * Goes through and compresses the assessment into a smaller format.
 */
export class AssessmentCompressorService
{
    public compress(assessment:Assessment) {
        let result = {_scales: [], _question_sets: []};
        Object.assign(result, assessment);
        result._scales = assessment.scales.map(s => this.compressScale(s));
        result._question_sets = assessment.question_sets.map(qs => this.compressQuestionSet(qs));
        return result;
    }

    private compressScale(scale:Scale) : CompressedScale {
        // for now we aren't compressing the scale at all.
        let compressedScale:any = Object.assign({}, scale, {_subScaleIds: scale.getSubScaleIds()});
        if (compressedScale.hasOwnProperty('_subScales')) {
            delete compressedScale._subScales;
        }
        return compressedScale;
    }

    private compressQuestionSet(questionSet:QuestionSet) {
        let result = {_display_conditions: []};
        Object.assign(result, questionSet);
        result._display_conditions = questionSet.display_conditions.map(dc => this.compressDisplayCondition(dc));
        return result;
    }

    private compressDisplayCondition(dc:DisplayCondition) {
        let result:CompressedDisplayCondition = {
            _answerId: dc.answer.id
            ,_questionId: dc.question.id
            ,_questionSetId: dc.questionSet.id
            ,_displayType: dc.displayType
        };
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/assessment-compressor.service.ts